
import Http from '../http';

class AutoBidMatrixLogsService {
  static async getAllLogs() {
    return Http.get('/autobidmatrix-logs'); // adjust path as per your backend route
  }

  static async getLogById(id) {
    return Http.get(`/autobidmatrix-logs/${id}`);
  }

  static async getLogsByCabRequestId(cabRequestId) {
    return Http.get(`/autobidmatrix-logs/${cabRequestId}`); // matches your custom route
  }

  static async createLog(data) {
    return Http.post('/autobidmatrix-logs', data);
  }

  static async updateLog(id, data) {
    return Http.put(`/autobidmatrix-logs/${id}`, data);
  }

  static async deleteLog(id) {
    return Http.delete(`/autobidmatrix-logs/${id}`);
  }
}

export default AutoBidMatrixLogsService;
